// extracted by mini-css-extract-plugin
export default {"tablePage":"TablePage_tablePage__h5Ur3","titleBar":"TablePage_titleBar__0CRsI"};